import { auth, database } from "../../App";
import { Dispatch } from "react";
import {
  CREATE_GAME,
  CREATE_GAME_SUCCESS,
  CREATE_GAME_FAILED,
  LEAVE_GAME,
  LEAVE_GAME_SUCCESS,
  LEAVE_GAME_FAILED,
  ENTER_GAME,
  ENTER_GAME_FAILED,
  ENTER_GAME_SUCCESS
} from "./types";

export const createGame = (
  gameName: string,
  isPublic: boolean,
  maxPlayers: number,
  cards: string[]
) => (dispatch: Dispatch<{ type: string }>) => {
  dispatch({ type: CREATE_GAME });
  const { currentUser } = auth;
  if (currentUser) {
    const newRef = database
      .ref("games")
      .child("created")
      .push();

    newRef
      .set({
        gameName,
        isPublic,
        maxPlayers,
        currentPlayers: 1,
        cards,
        usedCards: [],
        id: newRef.key,
        moderator: currentUser.uid,
        currentSpeaker: null,
        currentIdea: null,
        maxScore: 100,
        timeLimit: null,
        players: {
          player_0: {
            id: currentUser.uid,
            cards: [],
            onCardSelected: null,
            Selected: null,
            score: 0
          },
          player_1: null,
          player_2: null,
          player_3: null,
          player_4: null,
          player_5: null,
          player_6: null,
          player_7: null
        },
        freePlayersGameId: [
          "player_1",
          "player_2",
          "player_3",
          "player_4",
          "player_5",
          "player_6",
          "player_7"
        ],
        started: false,
        status: "room"
      })
      .then(() => {
        database
          .ref("users")
          .child(currentUser.uid)
          .child("profile")
          .child("gameId")
          .set(newRef.key)
          .then(() => dispatch({ type: CREATE_GAME_SUCCESS }));
      });
  } else {
    dispatch({ type: CREATE_GAME_FAILED });
  }
};

export const enterGame = (gameId: string) => (
  dispatch: Dispatch<{ type: string }>
) => {
  const { currentUser } = auth;
  if (currentUser) {
    dispatch({ type: ENTER_GAME });
    database
      .ref("games")
      .child("created")
      .child(gameId)
      .transaction(game => {
        if (game && game.currentPlayers < game.maxPlayers) {
          database
            .ref("users")
            .child(currentUser.uid)
            .child("profile")
            .child("gameId")
            .set(gameId);
          dispatch({ type: ENTER_GAME_SUCCESS });
          const [myPlayerId, ...rest] = game.freePlayersGameId;
          return {
            ...game,
            currentPlayers: (game.currentPlayers || 0) + 1,
            freePlayersGameId: rest,
            players: {
              ...game.players,
              [myPlayerId]: {
                id: currentUser.uid,
                score: 0
              }
            }
          };
        }

        dispatch({ type: ENTER_GAME_FAILED });
        return game;
      });
  }
};

export const leaveGame = (
  playerID: string,
  gameId: string,
  parentStatus: string
) => (dispatch: Dispatch<{ type: string }>) => {
  const { currentUser } = auth;
  if (currentUser !== null) {
    dispatch({ type: LEAVE_GAME });
    database
      .ref("games")
      .child(parentStatus)
      .child(gameId)
      .transaction(value => {
        if (value) {
          if (value.status === "room") {
            if (
              value.currentPlayers === 1 &&
              value.players[playerID] !== null
            ) {
              dispatch({ type: LEAVE_GAME_SUCCESS });
              return null;
            } else {
              dispatch({ type: LEAVE_GAME_SUCCESS });
              return {
                ...value,
                players: {
                  ...value.players,
                  [playerID]: null
                },
                currentPlayers: (value.currentPlayers || 0) - 1,
                freePlayersGameId: [...value.freePlayersGameId, playerID]
              };
            }
          } else {
            return value;
          }
        } else {
          return value;
        }
      })
      .catch(e => console.log("e", e))
      .then(() => {
        database
          .ref("users")
          .child(currentUser.uid)
          .child("profile")
          .child("gameId")
          .remove();
      });
  } else {
    return dispatch({ type: LEAVE_GAME_FAILED });
  }
};
